/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IInputButtonProps extends React.ComponentPropsWithRef<"button"> {
	className?: string;
	active?: boolean;
}

export const InputButton: React.FC<IInputButtonProps> = ({ className, children, active, ...buttonProps }) => {
	const baseClass = BEM("edt-input-button", null, { active });

	if (className) {
		baseClass.add(className);
	}

	return (
		<button className={baseClass.toClassName()} {...buttonProps}>
			{children}
		</button>
	);
};

InputButton.defaultProps = {
	type: "button"
};
